<app-loader [isLoading]="isLoading"></app-loader>

<div class="header">
    <div class="top">
        <a routerLink="/home/communication/incorporation">
            <h3>Incorporaciones /</h3>
            <div class="breadcrumb">
                <mat-icon svgIcon="arrow back"></mat-icon>
                <h2> {{addition.title}}</h2>
            </div>
        </a>
    </div>
</div>
<div class="content form">
    <form [formGroup]="incorporateForm">
        <h4>Título:</h4>
        <mat-form-field appearance="outline" id="title-form-field"
            [class.mat-form-field-invalid]="incorporateForm.get('title')?.invalid && incorporateForm.get('title')?.touched">
            <input type="text" matInput placeholder="Título" formControlName="title">
            @if (incorporateForm.get('title')?.hasError('required')) {
            <mat-error>
                El título es obligatorio
            </mat-error>
            }
        </mat-form-field>
        <h4>Contenido:</h4>
        <quill-editor formControlName="observation" [modules]="modules" [styles]="{height: '300px'}"></quill-editor>

        @if (incorporateForm.get('observation')?.invalid && incorporateForm.get('observation')?.touched) {
        <div class="error-message">
            El contenido es obligatorio
        </div>
        }

        <h4>Tipo:</h4>
        <mat-form-field appearance="outline">
            <mat-label>Tipo</mat-label>
            <mat-select formControlName="toppings">
                @for (topping of toppingList; track topping) {
                <mat-option [value]="topping">{{topping}}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </form>

    <br>
    <mat-checkbox [(ngModel)]="isProgrammed" [ngModelOptions]="{standalone: true}">Programada</mat-checkbox>

    @if (isProgrammed) {
    <br><br><br>
    <mat-form-field appearance="outline">
        <mat-label>Fecha</mat-label>
        <input matInput [matDatepicker]="datepicker" [(ngModel)]="dateValue" [ngModelOptions]="{standalone: true}">
        <mat-datepicker #datepicker />
        <mat-datepicker-toggle [for]="datepicker" matSuffix />
    </mat-form-field>

    <mat-form-field appearance="outline">
        <mat-label>Hora</mat-label>
        <input matInput type="time" [(ngModel)]="timeValue" [ngModelOptions]="{standalone: true}">
        <mat-icon matSuffix>access_time</mat-icon>
    </mat-form-field>

    <p>Fecha y hora programada: {{getFormattedDateTime()}}</p>
    <br>
    }

    <!-- Image upload/preview section with @if directives -->
    @if (addition.image_url) {
    <div class="media-header">
        <h4>Imagen actual:</h4>
    </div>
    <div class="existing-media">
        <div class="media-item">
            <div class="image-container">
                <img [src]="addition.image_url" alt="Incorporation image" class="media-preview">
                <button mat-icon-button color="warn" type="button" (click)="removeImage()" class="delete-image-btn">
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
            <div class="media-info">
                <p>{{addition.image_url.split('/').pop() || 'Imagen de la incorporación'}}</p>
            </div>
        </div>
    </div>
    } @else {
    <h4>Imagen:</h4>
    <app-upload-files [singleFile]="true" (filesSelected)="onFileSelected($event)"></app-upload-files>
    }

    <br>
    <div class="buttons">
        <button mat-flat-button id="action" (click)="saveChanges()">Guardar cambios</button>
        <button mat-flat-button id="cancel" routerLink="/home/communication/incorporation">Cancelar</button>
    </div>
</div>